import { PlusOutlined } from "@ant-design/icons";
import { Button, message, Upload, UploadProps } from "antd";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { API_CENTER } from "../../../../services/api/api";
import { useAppDispatch } from "../../../../store/reduxHooks";
import { SEARCH_UP_DATA_DOCUMENTS_ID } from "../../../../store/slice/requestAppSlise/requestAppSlise";
import { validateFile } from "../../../../utils/utilities/validateFile";

import classes from "./DocNewFile.module.css";

/**
 * Компонент с кнопкой и функционалом для добавления дополнительного документа в роли КЛИЕНТА и АГЕНТА
 */
export function DocNewFile(): ReactElement {
  const formFileData = new FormData();
  const API = new API_CENTER();
  const { id } = useParams();
  const dispatch = useAppDispatch();

  const props: UploadProps = {
    showUploadList: false,
    beforeUpload: (file) => {
      const { isValidate, error } = validateFile(file);
      if (isValidate) {
        formFileData.append("type_doc_id", `10`);
        formFileData.append("file", file);
        API.GET_API(`file/${id}`, "POST", formFileData)
          .then((res) => {
            if (res.success) {
              // необходимо искать файлы по id изучить какое подойдет
              dispatch(
                SEARCH_UP_DATA_DOCUMENTS_ID({
                  document: res.data,
                  id: true,
                }),
              );
            }
            formFileData.delete("type_doc_id");
            formFileData.delete("file");
            formFileData.delete("bank_id");
          })
          .finally(() => {
            formFileData.delete("type_doc_id");
            formFileData.delete("file");
            formFileData.delete("bank_id");
          });
      } else {
        formFileData.delete("type_doc_id");
        formFileData.delete("file");
        formFileData.delete("bank_id");
        message.error(error);
      }
      return false;
    },
  };

  return (
    <Upload {...props}>
      <Button className={classes.button} type="primary">
        <PlusOutlined className={classes.icon} />
        Добавить дополнительные документы
      </Button>
    </Upload>
  );
}
